document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.printable-buttons > button').addEventListener('click', () => {
    window.print();
  }, false);
}, false);
